import { render } from "./BuzzLinkPreview.vue?vue&type=template&id=14b5bf2d&scoped=true"
import script from "./BuzzLinkPreview.vue?vue&type=script&lang=js"
export * from "./BuzzLinkPreview.vue?vue&type=script&lang=js"

import "./buzz-link-preview.scss?vue&type=style&index=0&id=14b5bf2d&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b5bf2d"]])

export default __exports__